<template>
  <modal
    v-model="localShow"
    class="modal--item"
    :header="false"
    @hide="closeModal"
    :size="modalClassSize">
    <div class="objective-header">
      <ObjectiveHeading
        :level="level"
        :title="title">
        <template slot="actions">
          <button
            class="btn"
            :class="levelButtonClass"
            @click="clickedPrint">
            <i class="fa fa-print"/> Print
          </button>
          <a
            class="close"
            :class="customCloseClass"
            role="button"
            @click="closeModal">
            <span>&times;</span>
          </a>
        </template>
      </ObjectiveHeading>
    </div>

    <div class="gb-text-2">
      <slot name="objective"/>
    </div>

    <div class="row" v-if="accessInfo.blur">
      <div class="col-sm-10 col-sm-offset-1">
        <LimitAccessAlert
          :auth-info="authInfo"
          :access-info="accessInfo"
          style="margin-top: 16px" />
      </div>
    </div>
    <ItemHeading :level="level">
      Student Task and Resources
    </ItemHeading>

    <template v-if="editorVisibility">
      <a
        :href="editItemUrl(itemId)"
        target="_blank"
        class="btn btn-xs btn-default pull-right"><i class="fa fa-pencil"/> Edit</a>
    </template>
    <p v-if="fetchingItem" class="text-muted text-center"><i class="fa fa-spin fa-circle-o-notch"/> Fetching item...</p>
    <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>

    <CopyTrackWrapper
      v-if="item"
      type="item"
      :title="title"
      :uuid="item.uuid"
      :demo="accessInfo.demo">
      <ItemView
        :item="item"
        v-if="item"
        :locked="accessInfo.blur"
        :level="level"/>
    </CopyTrackWrapper>

    <div slot="footer">
      <button
        class="btn"
        :class="levelButtonClass"
        @click="clickedPrint">
        <i class="fa fa-print"/> Print
      </button>
      <button
        class="btn btn-default"
        @click="closeModal">Close</button>
    </div>
  </modal>
</template>

<script>
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import ItemHeading from '@/components/goals/ItemHeading'
import ObjectiveHeading from '@/components/goals/ObjectiveHeading'
import ItemView from '@/components/goals/ItemView'
import LimitAccessAlert from '@/components/LimitAccessAlert'
import { mapGetters } from 'vuex'
import { pathwaysUrls } from '@/links'
import itemMixin from '@/components/goals/common/item_mixin'
import { isValidObjectiveLevel, levelButtonClass } from '@/components/goals/common/objectives'

export default {
  name: 'ItemModal',
  components: {
    ItemView,
    ObjectiveHeading,
    LimitAccessAlert,
    CopyTrackWrapper,
    ItemHeading
  },
  mixins: [itemMixin],
  props: {
    itemId: {
      type: String,
      required: true
    },
    level: {
      type: String,
      required: true,
      validator: isValidObjectiveLevel
    },
    title: {
      type: String,
      default: 'Sample Assessment Item'
    },
    show: {
      type: Boolean,
      default: false
    },
    accessInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errorMessage: '',
      fetchingItem: false,
      localShow: this.show
    }
  },
  computed: {
    modalClassSize() {
      return this.item && this.item.passages.length > 0 ? 'xlg' : 'lg'
    },
    levelButtonClass() {
      return levelButtonClass(this.level)
    },
    customCloseClass() {
      return `close-${this.level}`
    },
    item() {
      return this.itemById(this.itemId)
    },
    ...mapGetters('user', ['authInfo']),
    ...mapGetters('visibility', ['editorVisibility', 'betaVisibility'])
  },
  watch: {
    show(newShow) {
      this.localShow = newShow
      if (newShow) {
        this.loadItem()
      }
    }
  },
  methods: {
    editItemUrl(id) {
      return pathwaysUrls.editItem(id)
    },
    closeModal() {
      this.$emit('update:show', false)
    },
    clickedPrint() {
      this.$emit('print')
    },
    loadItem() {
      this.fetchingItem = true
      this.errorMessage = ''
      this.fetchItem(this.itemId).then(
        () => {
          this.fetchingItem = false
        },
        err => {
          this.errorMessage = err
        }
      )
    }
  }
}
</script>

<style lang="less">
.modal--item {
  .modal-dialog {
    /* provides extra scroll space in case there are popovers that are close to the bottom */
    margin-bottom: 200px;
  }
  .modal-body {
    padding-top: 72px;
  }
}
</style>

<style scoped lang="less">
@import '~@/mixins.less';

.objective-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.close {
  opacity: 0.65;
  color: white;
  text-shadow: none;
  font-size: 36px;
  font-weight: 300;
  line-height: 9px;
  float: none;
  position: relative;
  top: 5px;
  margin-left: 8px;
  &:hover {
    opacity: 1;
  }
  &.close-1st {
    color: @teal;
  }
  &.close-2nd {
    color: @blue;
  }
  &.close-3rd {
    color: @purple;
  }
}
</style>
